import { render, staticRenderFns } from "./safetyActionTargetDetail.vue?vue&type=template&id=4e74e5cb"
import script from "./safetyActionTargetDetail.vue?vue&type=script&lang=js"
export * from "./safetyActionTargetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e74e5cb')) {
      api.createRecord('4e74e5cb', component.options)
    } else {
      api.reload('4e74e5cb', component.options)
    }
    module.hot.accept("./safetyActionTargetDetail.vue?vue&type=template&id=4e74e5cb", function () {
      api.rerender('4e74e5cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sat/safetyActionTargetDetail.vue"
export default component.exports